export default "__VITE_ASSET__098d6167__"